import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import { LogService } from "@/services/logging";
import AppModule from "@/store/modules/app";
import UserModule from "@/store/modules/user";
import { computed, defineComponent, onMounted, ref } from "vue";
export default defineComponent({
  name: "UserGroupsSelect",
  setup: function setup() {
    var value = ref(null); // User groups that could be selected

    var userGroups = computed(function () {
      var userGroups = UserModule.selectableUserGroups;
      return userGroups.map(function (g) {
        return {
          value: g.group.id,
          label: g.group.name
        };
      });
    }); // Select the first group when component is mounted

    onMounted(function () {
      var groups = userGroups.value;

      if (groups.length) {
        var firstGroup = groups[0];

        if (firstGroup) {
          value.value = firstGroup.value;
          AppModule.setGID(firstGroup.value);
        }
      }
    }); // Function that allows a user to select their group.

    function selectGroup(val) {
      LogService.info("User selected groupId: ".concat(val), {
        selectableGroupList: UserModule.selectableUserGroups,
        selectedGroup: val
      });
      AppModule.setGID(val);
    }

    return {
      value: value,
      options: userGroups,
      selectGroup: selectGroup
    };
  }
});